'use client';

import { useAtomValue } from 'jotai/react';
import {
  showSortMenuAtom,
  showTagTabsAtom,
} from '../../_components/design-state';

export function TabsContainer({ children }: { children: React.ReactNode }) {
  const showTagTabs = useAtomValue(showTagTabsAtom);
  const showSortMenu = useAtomValue(showSortMenuAtom);
  if (!showTagTabs && !showSortMenu) {
    return null;
  }
  return (
    // Use margin to let 2 blocks nearby to collapse into one
    <div className="home-browser-controls mt-16 flex w-full flex-col justify-between gap-8 [@media(min-width:1150px)]:flex-row">
      {children}
    </div>
  );
}
